export function buildScheduledMessageLoadingState({
  itemId,
  cancellingId,
  deletingId,
  retryingId,
  resendingId,
  dispatchingId,
  sendingTemplateId,
  cancelling,
  deleting,
  retrying,
  resending,
  dispatching,
  sendingTemplate,
}) {
  if (cancellingId === itemId || cancelling) {
    return { activeActionId: 'cancel' };
  }
  if (deletingId === itemId || deleting) {
    return { activeActionId: 'delete' };
  }
  if (retryingId === itemId || retrying) {
    return { activeActionId: 'retry' };
  }
  if (resendingId === itemId || resending) {
    return { activeActionId: 'resend' };
  }
  if (dispatchingId === itemId || dispatching) {
    return { activeActionId: 'force_dispatch' };
  }
  if (sendingTemplateId === itemId || sendingTemplate) {
    return { activeActionId: 'send_template' };
  }
  return { activeActionId: null };
}
